import { collection,addDoc } from 'firebase/firestore'  
import { db } from './firebase-config';



export  async  function CreateData(dataName,data) {
 const dataRef =  collection(db,String(dataName))
await addDoc(dataRef,data)
return true

} 
//this function require only two parimeters
//call it in component with two prams 
//first is the name of the collection(string) in which you want to add document i.e Blog
//2nd is the data itself (string,object,array) what ever
//so call it like CreateData('Blog',data);